var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelpDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 480,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 105,
    width: 480,
    height: 480
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-111 -105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.895 165C450.249 165 530.79 245.542 530.79 344.895 530.79 444.249 450.249 524.79 350.895 524.79 251.542 524.79 171 444.249 171 344.895 171.113 245.589 251.589 165.113 350.895 165M350.895 155C246.019 155 161 240.019 161 344.895 161 449.771 246.019 534.79 350.895 534.79 455.771 534.79 540.79 449.771 540.79 344.895 540.837 240.066 455.894 155.047 351.065 155 351.009 155 350.951 155 350.895 155Z",
    stroke: "#000000",
    strokeWidth: 17.3333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.895 415 345.895 415 345.895 356.635 350.895 356.635C384.485 356.638 411.717 329.41 411.72 295.82 411.723 262.23 384.495 234.998 350.905 234.995 317.315 234.992 290.083 262.22 290.08 295.81 290.08 295.811 290.08 295.814 290.08 295.815L280.08 295.815C280.081 256.702 311.789 224.995 350.901 224.996 390.014 224.997 421.72 256.705 421.72 295.818 421.72 332.992 392.977 363.838 355.895 366.46Z",
    stroke: "#000000",
    strokeWidth: 17.3333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361 450C361 455.523 356.523 460 351 460 345.477 460 341 455.523 341 450 341 444.477 345.477 440 351 440 356.523 440 361 444.477 361 450Z",
    stroke: "#000000",
    strokeWidth: 17.3333
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpDark);
export default __webpack_public_path__ + "static/media/help_dark.1d2310e715cbcd0829d0d348ce2f8218.svg";
export { ForwardRef as ReactComponent };